import { Component, inject } from '@angular/core';
import { MachineTypeService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  MachineTypeCreateDto,
  MachineTypeDto,
  MachineTypeExcelDownloadDto,
  MachineTypeUpdateDto,
} from '../proxy/general/dtos/machine-type';
import { MACHINETYPE_CONFIG, MACHINETYPE_FIELDS } from './machine-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-machine-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, MachineTypeService, ConfirmationService],
  templateUrl: './machine-type.html',
  styleUrl: './machine-type.scss',
})
export class MachineType extends BaseCrudComponent<
  MachineTypeDto,
  MachineTypeCreateDto,
  MachineTypeUpdateDto,
  MachineTypeExcelDownloadDto
> {
  service = inject(MachineTypeService);
  config = MACHINETYPE_CONFIG;
  fields = MACHINETYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: MachineTypeDto): MachineTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'MachineType';
  }
}
